
export const GO_PLANNER_POPUP = document.getElementById('go-planner-popup');

export const ENQUIRE_LINK = GO_PLANNER_POPUP ? GO_PLANNER_POPUP.dataset.enquirelink : '';

export const PLANNER_LINK = GO_PLANNER_POPUP ? GO_PLANNER_POPUP.dataset.plannerlink : '';

export const PLANNER_BOOK_TEXT = GO_PLANNER_POPUP ? GO_PLANNER_POPUP.dataset.panelbookingtext : '';

export const ADD_LISTENER_NAME = 'onAddToCampaign';

export const PLANNER_STORAGE_KEY = 'go_planner';
